"use client";

import createSvgIcon from "./utils/createSvgIcon.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("path", {
  d: "M17 4h-3V2h-4v2H7v18h10zm-6 16v-5.5H9L13 7v5.5h2z"
}), 'BatteryChargingFullSharp');